'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var all = require('it-all');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var all__default = /*#__PURE__*/_interopDefaultLegacy(all);

const sortAll = (iterable, sorter) => {
  return async function* () {
    const values = await all__default["default"](iterable);
    yield* values.sort(sorter);
  }();
};
const replaceStartWith = (s, r) => {
  const matcher = new RegExp('^' + r);
  return s.replace(matcher, '');
};

exports.replaceStartWith = replaceStartWith;
exports.sortAll = sortAll;
